
export function GenerateId(){
    return Math.floor((Math.random() * 100000000) + 1)
}
